import React from 'react';
import PropTypes from 'prop-types';
import { getDurationText } from 'helpers/VideoHelper';
import Style from './DescriptionMeta.module.scss';

const DescriptionMeta = ({ durationInSeconds, contentRating }) => {
  const durationText = getDurationText(durationInSeconds);
  const rating = contentRating?.toUpperCase();
  const meta = [durationText, rating].filter(text => text).join('  ·  ');
  return <div className={Style.descriptionMeta}>{meta}</div>;
};

DescriptionMeta.propTypes = {
  durationInSeconds: PropTypes.number,
  contentRating: PropTypes.string,
};

export default DescriptionMeta;
